import { useTranslation } from 'react-i18next';
import type { ILawPartProps } from './ILawPartProps';
import { lawValue } from './lawGroups';
import { severityDot } from './lawTones';

/**
 * «Колізії з чинним законодавством» (прототип v4 lawConf): невирішені колізії — крапка кольору серйозності, назва, «вид · серйозність ·
 * стаття ↔ акт» (прочерк «—» пропускається); без колізій — «Відкритих колізій немає.».
 */
export function LawConflicts({ law, labels, onOpen }: ILawPartProps) {
  const { t } = useTranslation();
  const items = law.of('ldconf').filter((r) => r.status !== 'Resolved');
  return (
    <section className="law-sec law-sec--tight">
      <div className="law-sec__title">{t('recordPage.law.conflicts')}</div>
      {!items.length && <span className="law__muted">{t('recordPage.law.noConflicts')}</span>}
      {items.map((r) => {
        const meta = [lawValue(r, 'article'), lawValue(r, 'act')].filter((x) => x && x !== '—').join(' ↔ ');
        return (
          <button key={r.id} type="button" className="law-conf" onClick={() => onOpen('ldconf', r)}>
            <span className="law-conf__dot" style={{ background: severityDot(r.values['severity']) }} />
            <span className="law-conf__body">
              <strong>{r.title}</strong>
              <span className="law-conf__meta">
                {labels.option('ldconf', 'ctype', r.values['ctype'])} · {labels.option('ldconf', 'severity', r.values['severity'])} · {meta}
              </span>
            </span>
          </button>
        );
      })}
    </section>
  );
}
